import React, { useEffect, useState } from "react";
import Pagination from "./Pagination";
import Loader from "./Loader";
import Link from "next/link";
import time from "../services/time/time";
import { useTimezone } from "../services/hooks/useTimezone";
import { useCurrentPage } from "../services/hooks/useCurrentPage";
import { REWARD_TYPES } from "../services/lib/loyalty/constants";
import paginateArray from "../util/paginateArray";

export default function RewardsHistory({ loyaltyInfo }) {
  const [events, setEvents] = useState([]);
  const [displayedEvents, setDisplayedEvents] = useState([]);

  const { currentPage } = useCurrentPage();
  const { timezone } = useTimezone();

  const PAGE_SIZE = 4;

  useEffect(() => {
    if (loyaltyInfo) {
      const { referred, reviews, orders, surveys } = loyaltyInfo;

      setEvents(
        [...referred, ...reviews, ...orders, ...surveys].sort(
          (a, b) => b.created - a.created
        )
      );
    }
  }, [loyaltyInfo]);

  useEffect(() => {
    setDisplayedEvents(paginateArray(events, currentPage, PAGE_SIZE));
  }, [events, currentPage]);

  if (!loyaltyInfo) {
    return (
      <section className="mb-8">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Loader />
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!events.length) {
    return null;
  }

  return (
    <section className="mb-8">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="text-center">Rewards history</h4>

            <table className="table table-bordered table-lg">
              <thead>
                <tr>
                  <th scope="col">Points earned</th>
                  <th scope="col">Reason</th>
                  <th scope="col">Date</th>
                </tr>
              </thead>
              <tbody>
                {displayedEvents.map((event) => (
                  <tr>
                    <td>{event.points}</td>
                    <td>
                      {REWARD_TYPES.REVIEW === event.type && (
                        <span>You submitted a product review.</span>
                      )}

                      {REWARD_TYPES.REFERRAL === event.type && (
                        <span>
                          You referred a friend and they used your unique
                          referral code to make a purchase.
                        </span>
                      )}

                      {REWARD_TYPES.SURVEY === event.type && (
                        <span>You responded to a survey</span>
                      )}

                      {REWARD_TYPES.ORDER === event.type && (
                        <span>
                          You placed an{" "}
                          <Link href={`/orders/${event.referenceId}/status`}>
                            <a>order</a>
                          </Link>
                          .
                        </span>
                      )}

                      {REWARD_TYPES.NEGATIVE_REVIEW === event.type && (
                        <span>
                          A review you submitted may have violated our{" "}
                          <Link href="/terms/review-guidelines">
                            <a>Review Guidelines</a>
                          </Link>
                          . Contact Support for additional information.
                        </span>
                      )}

                      {REWARD_TYPES.ADMIN === event.type && (
                        <span>
                          We updated your Points balance. Contact Support to
                          learn why.
                        </span>
                      )}
                    </td>
                    <td>
                      {time
                        .unix(event.created)
                        .tz(timezone)
                        .format("MMM DD, YYYY hh:mm A")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Pagination
              numPages={parseInt(Math.ceil(events.length / PAGE_SIZE))}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
